export default __webpack_public_path__ + "static/media/integrandCheck.ebf05287.svg";